/*
 * @Author: zhechuan.Wang
 * @Date: 2023-11-28 09:45:27
 * @LastEditors: zhechuan.Wang
 * @LastEditTime: 2024-10-15 10:57:29
 * @Description: file content
 * @FilePath: \gfmis-card-ppt\src\views\mixins\common.js
 */
import XEUtils from "xe-utils";
import treeApi from '@/api/cardTree'

export default {
  data() {
    return {
      Api: null,
      loading: false,
      hasPager: true,  // 是否分页
      yearValue: '全部',
      treeList: [],
      tableData: [],
      pageConfig: {
        currentPage: 1,
        pageSize: 50,
        total: 0,
        pagerCount: 5,
        pageSizes: [50, 100, 200, 500, 1000],
        layouts: 'prev,pager,next,jumper,sizes,total',
      },
      mofDivCode: '',
      mofDivName: '',
      defaultOpenTrees: [], // 默认展开树节点
      isParentNode: true, // 当前选中树节点
    }
  },
  computed: {
    getTitleArr() {
      const { mofDivName, spName } = this.$store.state.subsidizeProject.subsidizeProject
      let titleArr = []
      if (mofDivName && spName) {
        titleArr = [mofDivName, spName]
      } else {
        titleArr = [...this.$store.getters.getTitleTvArray]
      }
      return titleArr
    }
  },
  mounted() {
  },
  methods: {
    // 树节点点击监听
    async treeNodeClick({ data, node }) {
      this.isParentNode = data.children?.length > 0
      this.mofDivName = data.label
      this.mofDivCode = data.value;
      this.tableConfig.titleTvArray = [this.mofDivName, '惠民惠农财政补贴项目清单']
      this.pageConfig.currentPage = 1
      this.getList()
    },
    // 设置请求参数与方法
    getListBefore({ currentPage = this.pageConfig.currentPage, pageSize = this.pageConfig.pageSize }) {
      return {
        method: this.Api.getList,
        args: {
          currentPage,
          pageSize,
          model: {}
        },
      };
    },
    // 获取数据
    async getList({ currentPage = this.pageConfig?.currentPage, pageSize = this.pageConfig?.pageSize } = {}) {
      this.loading = true;
      this.tableData = [];
      const { args, method } = await this.getListBefore({ currentPage, pageSize });
      args.model.isParent = this.isParentNode ? 1 : 0;
      args.model.searchBox = this.searchParam || ''

      const { data: res } = await method(args)['finally'](() => { this.loading = false })
      if (res.code !== 0 && res.code !== 200) {
        return this.$message.error(res.msg);
      }
      if (this.hasPager) {
        const { records, current, size, total, pages } = res.data;
        this.tableData = records;
        this.pageConfig = {
          ...this.pageConfig,
          currentPage: current,
          pageSize: size,
          total,
          pages
        };
      } else {
        this.tableData = res.data;
      }
      this.getListAfter instanceof Function && this.getListAfter({ data: res.data });
    },
    async getTreeData(isHomePage) {
      const { mof_div_code } = this.$route.query;
      const { mofDivCode, mofDivName } = this.$store.state?.subsidizeProject?.subsidizeProject || {};
      let defaultCheckedKeys = [];
      if (mofDivCode) {
        defaultCheckedKeys = [mofDivCode];
      }
      const { data: res } = await treeApi.divTree({ mofDivCode: mof_div_code || '' })
      if (res.code !== 200 && res.code !== 0) {
        return this.$message.error(res.msg)
      }
      this.treeList = res.data || []
      this.defaultOpenTrees = []
      if (this.treeList.length > 0) {
        this.defaultOpenTrees.push(this.treeList[0].id)
      }
      XEUtils.eachTree(this.treeList, item => {
        if (item) {
          item.open = true;
          item.label = item.label.replace(/.*-/g, '');
          item.value = item.id;
          item.isDisabeld = !item.open

          if (!item.pid?.length || item.pid == '-1') {
            this.mofDivCode = item.value;
            this.mofDivName = item.label;
          }
          if (mof_div_code && mof_div_code == item.value) {
            this.mofDivCode = item.value;
            this.mofDivName = item.label;
          }
          if (!isHomePage && defaultCheckedKeys?.length > 0) {
            this.mofDivCode = mofDivCode;
            this.mofDivName = mofDivName;
          }
        }
      })
      return {
        mofDivCode: this.mofDivCode,
        mofDivName: this.mofDivName,
      }
    },
    async searchChange(searchTv) {
      this.pageConfig.currentPage = 1
      this.searchParam = searchTv;
      await this.getList();
      this.searchKeywords()
    },
    // 查询文本设置高亮颜色
    searchKeywords(domClass = '.rowText') {
      this.$nextTick(() => {
        let doms = document.querySelectorAll('#searchKey');
        for (let i = 0; i < doms.length; i++) {
          let item = doms[i]
          item.style.color = 'inherit'
        }
        if (this.searchParam != '') {
          let doms = document.querySelectorAll(domClass);
          for (let i = 0; i < doms.length; i++) {
            let item = doms[i]
            const str = item.innerHTML
            const substr = "/(" + this.searchParam + ")/g";
            let newContent = str.replace('<span id=searchKey style=color: inherit;', '')
            newContent = newContent.replace('</span>', '')
            const replaceStr = newContent.replace(eval(substr), "<span id='searchKey' style='color:red !important'>" + this.searchParam + "</span>")
            item.innerHTML = replaceStr
          }
        }
      })

    },
    // 监听点击每页条数
    handleSizeChange(val) {
      this.pageConfig.pageSize = val
      this.getList()
    },
    // 监听切换页回调
    handleCurrentChange(val) {
      this.pageConfig.currentPage = val
      this.getList()
    }
  }
}